<template>
  <a-card class="page-container">
    <search-form
      :form="searchForm"
      :group-list="groupList"
      @search="handleSearch"
      @reset="handleReset"
    />

    <div class="oper-bar">
      <a-button
        type="primary"
        :loading="exporting"
        @click="handleExport"
      >
        导出当前搜索条件数据  
      </a-button>
    </div>

    <data-table
      :loading="loading"
      :data="studyList"
      :pagination="pagination"
      @pagination-change="handlePaginationChange"
      @action-click="handleActionClick"
    />
  </a-card>
</template>

<script>
import SearchForm from './components/SearchForm'
import DataTable from './components/DataTable'
import { downloadExcel } from '@/utils'
import https from '@/api/kpi.js'
import activityApi from '@/api/activity'

export default {
  name: 'actStudyOperAssi',
  components: {
    SearchForm,
    DataTable  
  },
  data () {
    return {
      searchForm: {
        dealer_name: '',
        account: '',
        user_name: '',
        mobile: '',
        account_group_id: ''
      },
      groupList: [],
      loading: false,
      studyList: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      exporting: false
    }
  },
  created () {
    this.fetchStudyList()
    this.fetchGroupList()
  },
  methods: {
    // 处理查询
    handleSearch () {
      this.pagination.current = 1
      this.fetchStudyList()
    },
    // 处理重置
    handleReset () {
      this.pagination.current = 1
      this.fetchStudyList()
    },
    // 处理分页改变
    handlePaginationChange (current, pageSize) {
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.fetchStudyList()
    },
    // 获取数据
    async fetchStudyList () {
      this.loading = true
      try {
        const { current, pageSize } = this.pagination
        const params = {
          activity_id: this.$route.query.activity_id,
          ...this.searchForm,
          page_num: current,
          page_size: pageSize
        }
        const { code, data, message  } = await https.getStudyList(params)
          
        if (code === 200) {
          this.studyList = data.list
          this.pagination.total = data.total
          this.loading = false
        } else {
          this.$message.error(message || '获取学情列表失败')
          this.loading = false
        }
      } catch (e) {
        this.loading = false
      }
    },
    // 获取分组列表
    async fetchGroupList () {
      try {
        const params = {
          group_name: ''
        }
        const { code, data, message } = await https.getGroupSelect(params)

        if (code === 200) {
          this.groupList = data
        } else {
          this.$message.error(message || '获取公共分组失败')
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 处理导出
    handleExport () {
      this.exportStudyList()
    },
    // 导出学情列表
    async exportStudyList () {
      this.exporting = true
      try {
        const params = {
          activity_id: this.$route.query.activity_id,
          ...this.searchForm
        }
        const res = await activityApi.exportStudyList(params)

        downloadExcel(res, '学情列表数据')
        this.exporting = false
      } catch (e) {
        console.log(e)
        this.exporting = false
      }
    },
    // 处理操作点击
    handleActionClick (type, record) {
      this.$router.push({
        name: 'dealer-detail',
        query: {
          dealer_id: record.dealer_id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  padding: 0 !important;
}

.oper-bar {
  margin: 10px 0 0;
  text-align: right;
}

.data-table {
  margin: 10px 0 0;
}
</style>
